<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label for="company.name">Company Name</label>
                        <input class="form-control form-control-sm" placeholder="Legal name of the client company"
                               type="text" name="company.name" id="company.name"
                               v-model="form.name">
                        <span class="help is-danger" v-if="form.errors.has('name')">
                            {{ form.errors.get('name') }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="company.organization_number">Org.nr</label>
                        <input class="form-control form-control-sm" type="text" placeholder="For Swedish clients"
                               name="company.organization_number" id="company.organization_number"
                               v-model="form.organization_number"/>
                        <span class="help is-danger" v-if="form.errors.has('organization_number')">
                            {{ form.errors.get('organization_number') }}
                        </span>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="company.vat_number">VAT/TAXID</label>
                        <input class="form-control form-control-sm" type="text"
                               placeholder="For clients outside of Sweden" name="company.vat_number"
                               id="company.vat_number"
                               v-model="form.vat_number"/>
                        <span class="help is-danger" v-if="form.errors.has('vat_number')">
                            {{ form.errors.get('vat_number') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <hr>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="company.address_line_1">Address Line 1</label>
                        <input class="form-control form-control-sm" type="text" name="company.address_line_1"
                               id="company.address_line_1"
                               v-model="form.address_line_1"/>
                        <span class="help is-danger" v-if="form.errors.has('address_line_1')">
                            {{ form.errors.get('address_line_1') }}
                        </span>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="company.address_line_2">Address Line 2</label>
                        <input class="form-control form-control-sm" type="text" name="company.address_line_2"
                               id="company.address_line_2"
                               v-model="form.address_line_2"/>
                        <span class="help is-danger" v-if="form.errors.has('address_line_2')">
                            {{ form.errors.get('address_line_2') }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="company.zip_code">Zip Code</label>
                        <input class="form-control form-control-sm" type="text" name="company.zip_code"
                               id="company.zip_code"
                               v-model="form.zip_code"/>
                        <span class="help is-danger" v-if="form.errors.has('zip_code')">
                            {{ form.errors.get('zip_code') }}
                        </span>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="company.city">City</label>
                        <input class="form-control form-control-sm" type="text" name="company.city" id="company.city"
                               v-model="form.city"/>
                        <span class="help is-danger" v-if="form.errors.has('city')">
                            {{ form.errors.get('city') }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label for="company.country">Country</label>
                        <input class="form-control form-control-sm" type="text" name="company.country"
                               id="company.country"
                               v-model="form.country"/>
                        <span class="help is-danger"
                              v-if="form.errors.has('country')">
                            {{ form.errors.get('country') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <hr>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label for="company.contact_person">Contact name</label>
                        <input class="form-control form-control-sm" type="text" name="company.contact_person"
                               id="company.contact_person"
                               v-model="form.contact_person"/>
                        <span class="help is-danger" v-if="form.errors.has('contact_person')">
                            {{ form.errors.get('contact_person') }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label for="company.contact_email">Contact email</label>
                        <input class="form-control form-control-sm" type="text" name="company.contact_email"
                               id="company.contact_email"
                               v-model="form.contact_email"/>
                        <span class="help is-danger" v-if="form.errors.has('contact_email')">
                            {{ form.errors.get('contact_email') }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label for="company.contact_phone">Contact phone</label>
                        <input class="form-control form-control-sm" type="text" name="company.contact_phone"
                               id="company.contact_phone"
                               v-model="form.contact_phone"/>
                        <span class="help is-danger" v-if="form.errors.has('contact_phone')">
                            {{ form.errors.get('contact_phone') }}
                        </span>
                    </div>
                </div>
            </div>
            <button type="button" class="btn btn-primary mt-4 btn-block" @click="store">
                {{ action }}
            </button>
        </div>
    </div>
</template>

<script>
  import TForm from './TForm';

  export default {
    props: {
      company: {
        type: Object,
        required: false,
        default: () => {
        },
      },
    },
    data() {
      return {
        form: new TForm({
          id: null,
          name: '',
          organization_number: '',
          address_line_1: '',
          address_line_2: '',
          zip_code: '',
          city: '',
          country: '',
          contact_person: '',
          contact_email: '',
          vat_number: '',
          contact_phone: '',
        }, true),
      };
    },
    watch: {
      company(newValue, oldValue) {
        Object.keys(this.form).forEach((key, index) => {
          if (newValue.hasOwnProperty(key)) {
            this.form[key] = newValue[key];
          }
        });
      },
    },
    computed: {
      action() {
        if (this.company.hasOwnProperty('id')) {
          return 'Update Company';
        }
        return 'Create Company';
      },
    },
    methods: {
      store() {
        this.form.post('/companies').then(data => {
          this.$emit('interface', data);
        }).catch(error => {
        });
      },
    },
  };
</script>
